export const gaEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number,
) => {
  // GA.event({ category, action, label, value });
};
